import { ReactNode } from 'react'

interface WithWrapperProps {
  wrapper: React.ElementType
  children: ReactNode
  wrapWhen: any
  [key: string]: any // Allow additional props to pass to the wrapper
}

export const WithWrapper: React.FC<WithWrapperProps> = ({
  wrapper: Wrapper,
  children,
  wrapWhen,
  ...props
}) => {
  if (wrapWhen) {
    return <Wrapper {...props}>{children}</Wrapper>
  }

  return <>{children}</>
}
